import React from "react";
import { CheckCircle2, ShieldCheck } from "lucide-react";

const PackageCard = ({ 
  name, price, duration, rate, padCount, 
  description, features = [], popular = false, onSubscribe 
}) => {
  return (
    <div className={`relative bg-white rounded-3xl shadow-xl transition-all duration-300 border-2 flex flex-col h-full ${
      popular ? "border-pink-400 lg:scale-105 z-10" : "border-transparent hover:border-pink-100"
    }`}>
      
      {popular && (
        <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-pink-500 text-white text-[10px] font-black px-4 py-1.5 rounded-full shadow-lg z-20 uppercase tracking-widest">
          Recommended
        </div>
      )}

      <div className="p-6 flex-1">
        <div className="flex justify-between items-start mb-4">
          <h3 className="text-2xl font-bold text-gray-800">{name}</h3>
          <ShieldCheck className={`w-6 h-6 ${popular ? 'text-pink-500' : 'text-gray-300'}`} />
        </div>

        <p className="text-xs text-gray-500 mb-6 leading-relaxed">{description}</p>
        
        <div className="mb-6">
          <div className="flex items-baseline gap-1">
            <span className="text-3xl font-black text-pink-600">₹{price}</span>
            <span className="text-gray-400 text-xs font-bold">/{duration === 'Base Product' ? 'Pack' : duration}</span>
          </div>
          <p className="text-[11px] text-pink-400 font-bold mt-1">
            Effective Rate: {rate}
          </p>
        </div>

        <div className="bg-pink-50 rounded-xl p-3 mb-6">
           <div className="text-sm font-bold text-pink-800">{padCount}</div>
        </div>

        <ul className="space-y-3 mb-6">
          {features.map((feature, idx) => (
            <li key={idx} className="flex items-start gap-2">
              <CheckCircle2 className="w-4 h-4 text-green-500 flex-shrink-0 mt-0.5" />
              <span className="text-[11px] text-gray-600 font-medium leading-tight">{feature}</span>
            </li>
          ))}
        </ul>
      </div>

      <div className="p-6 pt-0">
        <button
          onClick={onSubscribe}
          className={`w-full py-4 rounded-xl font-bold transition-all transform active:scale-95 text-xs uppercase tracking-widest ${
            popular
              ? "bg-pink-500 text-white hover:bg-pink-600 shadow-md shadow-pink-200"
              : "bg-gray-900 text-white hover:bg-black"
          }`}
        >
          Subscribe
        </button>
      </div>
    </div>
  );
};

export default PackageCard;